const checkScrollPosition = (scrollableDiv, nextButton) => {
  // Ensure both scrollableDiv and nextButton exist before proceeding
  if (scrollableDiv && nextButton) {
    // Show the button only if the contents are scrollable
    if (scrollableDiv.scrollWidth > scrollableDiv.clientWidth) {
      nextButton.classList.add('visible');
    } else {
      nextButton.classList.remove('visible');
    }
  }
};

const addColorSwatchListeners = () => {
  const productCards = document.querySelectorAll('.grid__item.grid-product');
  
  if (!productCards) {
    // If no product cards are found, exit the function early
    return;
  }

  productCards.forEach((productCard) => {
    const productId = productCard.getAttribute('data-id');

    if (!productId) {
      // If productId is not found, skip to the next productCard
      return;
    }

    const nextButton = document.getElementById(`next-swatch-${productId}`);
    const scrollableDiv = document.getElementById(`custom-grid-product__colors-scrollable-${productId}`);
    const productLink = document.querySelector(`a[data-product-id="${productId}"]`);
    const productGridSlider = productLink 
      ? productLink.querySelector(`#ProductGridSlider-${productId}`)?.querySelectorAll('.product-slide')[0]
      : null;
    const productFeaturedImage = productGridSlider ? productGridSlider.querySelector('img') : null;
    const shopNowButton = document.getElementById(`product-grid--shopcta-${productId}`);
    const gridProductLinkWrap = productCard.querySelector('.grid-product__link-wrap');
    const currentSwatch = scrollableDiv ? scrollableDiv.querySelector('.custom-swatch-selected') : null; // Track the initially selected swatch
    const gridProductPrice = productCard.querySelector('.grid-product__price');

    const transparentImage =
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/Vi2XAAAAABJRU5ErkJggg==';

    // Add event listener to nextButton if it exists
    if (nextButton && scrollableDiv) {
      nextButton.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        scrollableDiv.scrollLeft += 25;
        checkScrollPosition(scrollableDiv, nextButton);
      });
    }

    // Add scroll event listener to scrollableDiv if it exists
    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', () => checkScrollPosition(scrollableDiv, nextButton));
    }

    const swatches = scrollableDiv ? scrollableDiv.querySelectorAll('.custom-color-swatch-inline') : [];

    if (productLink && swatches.length > 0) {
      swatches.forEach((swatch) => {
        const colorSwatchValue = swatch.getAttribute('data-color-value') || '';
        
        // Initialize tippy only if swatch exists
        if (swatch) {
          tippy(swatch, {
            content: colorSwatchValue,
            animation: 'custom',
          });
          swatch.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const hrefUrl = swatch.getAttribute('data-href-url');
            if (hrefUrl && window.screen.width > 768) {
              window.location.href = hrefUrl; // Navigate to the URL
            } else {
              console.error('No URL found in data-href attribute.');
            }
          });
          swatch.addEventListener('mouseenter', () => {
            const imageUrl = swatch.getAttribute('data-image-url');
            const hrefUrl = swatch.getAttribute('data-href-url');
            const variantId = swatch.getAttribute('data-variant-id');
            const isAvailable = swatch.getAttribute('data-available') === 'true';

            if (variantId) {
              gridProductPrice.children[0].setAttribute('data-spresso-item-id', variantId);
              gridProductPrice.children[0].setAttribute('data-spresso-fallback-id', variantId);
              if (isAvailable) {
                gridProductPrice.children[0].removeAttribute('data-spresso-oos');
              } else {
                gridProductPrice.children[0].setAttribute('data-spresso-oos', '');
              }
              gridProductPrice.children[0].innerHTML = `&nbsp;`;
            }
            
            if (hrefUrl && productLink && shopNowButton && gridProductLinkWrap && productFeaturedImage) {
              productLink.setAttribute('data-url', hrefUrl);
              productLink.setAttribute('href', hrefUrl);
              shopNowButton.setAttribute('href', hrefUrl);
              gridProductLinkWrap.setAttribute('href', hrefUrl);
  
              // Set the transparent placeholder image first
              productFeaturedImage.setAttribute('src', transparentImage);
              productFeaturedImage.setAttribute('srcset', transparentImage);
  
              // Update the current swatch to the one being hovered
              if (currentSwatch) {
                currentSwatch.classList.remove('custom-swatch-selected'); // Remove border from the previous swatch
              }
              swatch.classList.add('custom-swatch-selected'); // Add border to the current swatch
              const updatedCurrentSwatch = swatch; // Update the current swatch variable
  
              // Create a new temporary image element to load the new image
              const tempImage = new Image();
              tempImage.src = imageUrl || '';
              tempImage.onload = function () {
                // Check if the current swatch is still the one being hovered
                if (updatedCurrentSwatch === swatch && imageUrl) {
                  // Once the image is loaded, set it to the actual image element
                  productFeaturedImage.setAttribute('src', imageUrl);
                  productFeaturedImage.setAttribute('srcset', imageUrl);
                }
              };
            }
          });
        }
      });
    }

    // Initial check to determine if the button should be visible
    checkScrollPosition(scrollableDiv, nextButton);
  });
};

window.addColorSwatchListeners = addColorSwatchListeners;

document.addEventListener('DOMContentLoaded', () => {
  window.addColorSwatchListeners();
});
